-表格搜索模塊
<template>
  <div v-if="lists.length > 0">
    <el-card shadow="never">
      <div class="input_wrap">
        <el-row :gutter="20">
          <el-col
            :span="3"
            v-for="(items, index) in lists"
            :key="index"
            :class="lists.length >= 8 ? 'input_box margin_bottom' : 'input_box'"
          >
            <div class="title" v-if="showTitle">
              <template>{{ items.title }}</template>
            </div>
            <!--文本-->
            <template v-if="items.style == 'text'">
              <el-input
                :placeholder="$t('search.input') + items.displayName"
                v-model="searchData[items.fieldName]"
                :size="size"
                class="input"
                style="width: 100%"
              ></el-input>
            </template>

            <!--狀態-->
            <template v-if="items.style == 'status'">
              <cc-constant-selector
                :placeholder="$t('search.selete') + items.displayName"
                valType="String"
                style="width: 100%"
                v-model="searchData[items.fieldName]"
                :code="items.dataSource"
                :clearable="items.clearable"
                api="admin/dict/pageTree"
              />
            </template>

            <!--時間-->
            <template v-if="items.style == 'time'">
              <el-date-picker
                type="datetime"
                :size="size"
                style="width: 100%"
                v-model="searchData[items.fieldName]"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="items.displayName"
              ></el-date-picker>
            </template>

            <!--選擇-->
            <template v-if="items.style == 'select'">
              <el-select
                v-model="searchData[items.fieldName]"
                :placeholder="$t('search.selete') + items.displayName"
                :size="size"
                :clearable="items.clearable===undefined?true:items.clearable"
              >
                <el-option
                  v-for="item in items.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>

            <template v-if="items.style == 'selector'">
              <cc-selector
                :config="items.selectorConfig"
                v-model="searchData[items.fieldName]"
                :placeholder="$t('search.selete') + items.displayName"
              />
            </template>
          </el-col>

          <el-col :span="1">
            <div class="title" style="opacity: 0" v-if="showTitle">1111</div>
            <el-button
              icon="el-icon-search"
              :size="size"
              class="search"
              @click="doSearch"
              >{{ $t("search.doSearch") }}</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "CcSearch",
  props: {
    layout: String, // y x
    size: {
      type: String,
      default: "mini",
    },
    config: {
      type: Array,
      required: true,
    },

    //配置示例
    //       searchConfig: [
    //     {
    //       title: "111",
    //       displayName: "ID", //顯示名
    //       fieldName: "id",//字段名
    //       style: "text", //樣式  status time text
    //       value: "1" // 默認值
    //     },
    //     {
    //       displayName: "活动名称", //顯示名
    //       fieldName: "activityName",//字段名
    //       style: "text" //樣式  status time text
    //       //   value: "1"
    //     },
    //     {
    //       displayName: "活动狀態", //顯示名
    //       fieldName: "status",//字段名
    //       dataSource: "status",
    //       style: "status" //樣式  status time text
    //       //   value: "0"
    //     },
    //     {
    //       displayName: "活动狀態", //顯示名
    //       fieldName: "status", //字段名
    //       style: "select", //樣式  status time text
    //       options: [
    //         {
    //           value: 1,
    //           label: 1,
    //         },
    //       ],
    //     },
    //   ]
  },
  data() {
    return {
      lists: [],
      searchData: {},
      showTitle: false,
    };
  },
  methods: {
    doSearch() {
      let obj = {};
      for (const key in this.searchData) {
        if (this.searchData[key]) {
          obj[key] = this.searchData[key];
        }
      }
      this.$emit("doSearch", obj);
    },
  },
  watch: {
    config: {
      handler() {
        this.lists = this.config;
        let searchData = {};
        for (let i = 0; i < this.lists.length; i++) {
          if (this.lists[i].value) {
            searchData[this.lists[i].fieldName] = this.lists[i].value;
          }
          if (this.lists[i].title) {
            this.showTitle = true;
          }
        }
        this.searchData = { ...searchData };
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style  scoped>
.input_box {
  min-width: 200px;
  max-width: 300px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.title {
  margin-bottom: 5px;
  height: 20px;
}
.search {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>